<template>
  <div class="spacetime-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$G_μν = 8πT_μν$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>天体质量 M</label>
            <span class="val">{{ mass.toFixed(1) }} <small>太阳质量</small></span>
          </div>
          <div class="hud-item orange">
            <label>时空曲率 (K)</label>
            <span class="val">{{ curvature.toFixed(2) }} </span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 静态时空网格 (Spacetime Grid) -->
          <g v-for="y in 10" :key="'y'+y">
             <path :d="generateGridLine(y, 'h')" fill="none" stroke="#334155" stroke-width="0.5" />
          </g>
          <g v-for="x in 15" :key="'x'+x">
             <path :d="generateGridLine(x, 'v')" fill="none" stroke="#334155" stroke-width="0.5" />
          </g>

          <!-- 大质量物体 (Massive Body) -->
          <circle cx="225" cy="120" :r="25 + mass" fill="#fbbf24" filter="url(#glow-m)" />
          
          <!-- 光线通过时的偏转路径 (Light Deflection) -->
          <path :d="lightPath" fill="none" stroke="#0ea5e9" stroke-width="2" stroke-dasharray="4,2" />
          <text x="50" y="80" fill="#0ea5e9" font-size="9">光线路径</text>

          <defs>
             <filter id="glow-m"><feGaussianBlur stdDeviation="5" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：引力并非一种真正的“力”，而是物质告诉时空如何弯曲，弯曲的时空告诉物质如何运动。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节中心天体质量 (M)：{{ mass.toFixed(1) }}</label>
                 <el-slider v-model="mass" :min="10" :max="60" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="info" size="mini" @click="mass = 12">白矮星级别</el-button>
                 <el-button size="mini" @click="mass = 50">黑洞边缘</el-button>
              </div>
           </div>
        </div>
        
        <!-- 原子专家级高对比度卡片 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-odometer"></i></div>
           <div class="text-content">
             <p><strong>实战物理/广义相对论：</strong>时空弯曲在爱因斯坦看来，引力是一个几何问题。<strong>解惑：</strong>为什么光不是直线走的？<strong>观察：</strong>调节中心质量滑块。你会发现背后的**时空网格被狠狠拉扯**，光在经过这里时会被拉向中心。这就是著名的**引力透镜效应**。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'EinsteinSpacetimeStatViz',
  data() {
    return {
      mass: 15
    }
  },
  computed: {
    curvature() { return this.mass / 10; },
    lightPath() {
       let d = "M 50,70 ";
       for(let x=50; x<=400; x+=10) {
          const r = Math.hypot(x - 225, 120 - 70);
          const deflection = (this.mass * 80) / Math.pow(r, 1.2);
          d += `L ${x},${70 + (x > 225 ? deflection : deflection * (x-50)/175)}`;
       }
       return d;
    }
  },
  methods: {
    generateGridLine(idx, type) {
       let d = "";
       if (type === 'h') { // Horizontal
          let y = idx * 24 - 12;
          d = `M 0,${y} `;
          for(let x=0; x<=450; x+=10) {
             const r = Math.hypot(x - 225, y - 120);
             const warp = (this.mass * 120) / (r + 40);
             d += `L ${x},${y + warp * (y > 120 ? 1 : -1) * (Math.abs(y-120)/80)}`;
          }
       } else { // Vertical
          let x = idx * 30 - 15;
          d = `M ${x},0 `;
          for(let y=0; y<=240; y+=10) {
             const r = Math.hypot(x - 225, y - 120);
             const warp = (this.mass * 120) / (r + 40);
             d += `L ${x + warp * (x > 225 ? 1 : -1) * (Math.abs(x-225)/120)},${y}`;
          }
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.spacetime-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
